<template>
  <div style="width: 100%;height: 100%;overflow: auto">

      <div style="width: 100%;display: flex;justify-content: center">
        <el-form ref="crmWin" :model="busData" style="width: 70%" :rules="rules" label-width="160px">
          <el-form-item label="是否335订单：" prop="is335" >
            <el-radio-group v-model="busData.is335" :disabled="isDisable">
              <el-radio :value="true" label="是"></el-radio>
              <el-radio :value="false" label="否"></el-radio>
            </el-radio-group>
          </el-form-item>
          <div v-if="busData.is335">
            <div style="width: 100%;height:auto;display: flex;justify-content:center;">
              <div style="width: 710px;display: flex;line-height: 30px;background-color: #cccccc;text-align:center;margin-top: 10px">
                <div style="width: 30px;background-color: white"></div>
                <div style="width: 30px;background-color: white"></div>
                <div style="width: 100px;">维护期</div>
                <div style="width: 150px">开始日</div>
                <div style="width: 150px">到期日</div>
                <div style="width: 250px">到期提前提醒</div>
              </div>
            </div>
            <el-scrollbar style="height: 180px;margin-top: 5px;" always>
              <div v-for="(item,index) in busData.productRemindList" style="width: 100%;display: flex;justify-content: center">
                <div style="width: 710px;height:35px;display: flex;line-height: 30px;margin-top: 10px;">
                  <div style="width:30px;display: flex; align-items: center; justify-content: center;cursor: pointer;"  @click="addLine">
                    <el-icon :size="22"><CirclePlus /></el-icon>
                  </div>
                  <div style="width: 30px;display: flex; align-items: center; justify-content: center;cursor: pointer;" @click="delLine(index)">
                    <el-icon :size="22"><Remove /></el-icon>
                  </div>
                  <div style="width: 100px; padding: 0 5px;text-align: center">
                    {{item.maintenancePhase}}
                  </div>
                  <div style="width: 150px">
                    <el-date-picker v-model="item.startDate" value-format="YYYY-MM-DD" style="width: 140px" :disabled="isDisable"></el-date-picker>
                  </div>
                  <div style="width: 150px;padding: 0 5px">
                    <el-date-picker v-model="item.endDate" value-format="YYYY-MM-DD" style="width: 140px" :disabled="isDisable"></el-date-picker>
                  </div>
                  <div style="width: 250px;padding: 0 5px;text-align: center">
                    <el-checkbox @change="selectAll(index)" v-model="item.all"
                                 style="width:50px;margin-right: 10px" :value="true" :disabled="isDisable">全部</el-checkbox>
                    <el-checkbox v-model="item.thirtyDays" :disabled="isDisable"
                                 style="width:50px;margin-right: 10px" :value="true">30天</el-checkbox>
                    <el-checkbox v-model="item.sixtyDays" :disabled="isDisable"
                                 style="width:50px;margin-right: 10px" :value="true">60天</el-checkbox>
                    <el-checkbox v-model="item.ninetyDays" :disabled="isDisable"
                                 style="width:50px" :value="true">90天</el-checkbox>
                  </div>
                </div>
              </div>
            </el-scrollbar>
          </div>
          <el-form-item label="合同签署公司：" prop="contractBelongCompany" >
            <el-select v-model="busData.contractBelongCompany" style="width: 200px" clearable :disabled="isDisable">
              <el-option v-for="company in companyList" :key="company.value" :label="company.label" :value="company.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否新客户：" prop="isNewCustomer" >
            <el-radio-group v-model="busData.isNewCustomer" :disabled="isDisable">
              <el-radio :value="true" label="是"></el-radio>
              <el-radio :value="false" label="否"></el-radio>
            </el-radio-group>
          </el-form-item>

          <!-------------新客户信息--------------->
          <div v-if="busData.isNewCustomer">
            <el-row :gutter="12">
              <el-col :span="12">
                <el-form-item label="企业名称：" >
                  <el-input v-model="busData.companyName" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="企业税号：">
                  <el-input v-model="busData.companyNo"  :disabled="isDisable"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="企业地址：">
              <el-input v-model="busData.taxAddress" :disabled="isDisable"></el-input>
            </el-form-item>
            <el-form-item label="电话号码：">
              <el-input v-model="busData.taxPhone" :disabled="isDisable"></el-input>
            </el-form-item>
            <el-form-item label="开户银行：">
              <el-input v-model="busData.taxBankName" :disabled="isDisable"></el-input>
            </el-form-item>
            <el-row :gutter="12">
              <el-col :span="12">
                <el-form-item label="每月付款日：">
                  <el-date-picker v-model="busData.paymentDate" type="date" :disabled="isDisable"
                                  value-format="MM-DD" format="MM-DD"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="每月开票日：">
                  <el-date-picker v-model="busData.invoicinDate" type="date" :disabled="isDisable"
                                  value-format="MM-DD" format="MM-DD" ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <el-form-item label="是否一套订单：" prop="isOneOrder" >
            <el-radio-group v-model="busData.isOneOrder" :disabled="isDisable">
              <el-radio :value="true" label="是"></el-radio>
              <el-radio :value="false" label="否"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否大单：" prop="isBigOrder" >
            <el-radio-group v-model="busData.isBigOrder" :disabled="isDisable">
              <el-radio :value="true" label="是"></el-radio>
              <el-radio :value="false" label="否"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否1拖N订单：" prop="isManyOrder" >
            <el-radio-group v-model="busData.isManyOrder" :disabled="isDisable">
              <el-radio :value="true" label="是"></el-radio>
              <el-radio :value="false" label="否"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否LC订单：" prop="isLcOrder" >
            <el-radio-group v-model="busData.isLcOrder" :disabled="isDisable">
              <el-radio :value="true" label="是"></el-radio>
              <el-radio :value="false" label="否"></el-radio>
            </el-radio-group>
          </el-form-item>
          <div v-if="busData.isLcOrder">
            <el-form-item label="LC类型：" prop="lcType" >
              <el-select v-model="busData.lcType" style="width: 200px" clearable :disabled="isDisable">
                <el-option  v-for="dict in legalTypeList" :key="dict.value" :label="dict.name" :value="dict.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="达索负责人：" prop="dassaultResponsibleUser" >
              <el-select v-model="busData.dassaultResponsibleUser" style="width: 200px" clearable :disabled="isDisable">
                <el-option  v-for="dict in dsLegalList" :key="dict.value" :label="dict.name" :value="dict.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="律师：" prop="lawyer" >
              <el-select v-model="busData.lawyer" style="width: 200px" clearable :disabled="isDisable">
                <el-option  v-for="dict in lawyerList" :key="dict.value" :label="dict.name" :value="dict.value"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <el-form-item label="是否2D-2D订单：" prop="is2dTo2d" >
            <el-radio-group v-model="busData.is2dTo2d" :disabled="isDisable">
              <el-radio :value="true" label="是"></el-radio>
              <el-radio :value="false" label="否"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="busData.is2dTo2d" label="原2D产品：" prop="originally2dProduct" >
            <el-select v-model="busData.originally2dProduct" :disabled="isDisable">
              <el-option  v-for="dict in twoDProductList" :key="dict.id" :label="dict.name" :value="dict.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否3D-3D订单：" prop="is3dTo3d" >
            <el-radio-group v-model="busData.is3dTo3d" :disabled="isDisable">
              <el-radio :value="true" label="是"></el-radio>
              <el-radio :value="false" label="否"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="busData.is3dTo3d" label="原3D产品：" prop="originally3dProduct" >
            <el-select v-model="busData.originally3dProduct" :disabled="isDisable">
              <el-option  v-for="dict in threeDProductList" :key="dict.id" :label="dict.name" :value="dict.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="维护续期类型：" style="margin-top: 10px">
            <el-select v-model="busData.maintainRenewalType" style="width: 200px" clearable :disabled="isDisable" @change="addSnInfoListLine()">
              <el-option v-for="item in maintainRenewalTypeList" :key="item.value" :label="item.name" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <div v-if="busData.maintainRenewalType">
            <el-row v-for="(item,index) in busData.snInfoList" :gutter="12" style="position: relative">
              <el-col :span="8">
                <el-form-item label="维护起始日期：" :prop="'snInfoList.' + index + '.maintainStartDate'"
                              :rules="rules.snInfoList.maintainStartDate" >
                  <el-date-picker v-model="item.maintainStartDate" :disabled="isDisable" value-format="YYYY-MM-DD"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="维护到期日期：" :prop="'snInfoList.' + index + '.maintainEndDate'"
                              :rules="rules.snInfoList.maintainEndDate" >
                  <el-date-picker v-model="item.maintainEndDate" :disabled="isDisable" value-format="YYYY-MM-DD"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="序列号：" label-width="80px">
                  <el-select style="width: 400px" v-model="item.serialNumber" :disabled="isDisable" >
                    <el-option  v-for="sn in snList" :key="sn.serial_number" :label="sn.serial_number" :value="sn.serial_number"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <div style="display: flex;position: absolute;right: -65px;top: 5px;" >
              <div style="width:30px;display: flex; align-items: center; justify-content: center;cursor: pointer;"  @click="addSnLine">
                <el-icon :size="22"><CirclePlus /></el-icon>
              </div>
              <div style="width: 30px;display: flex; align-items: center; justify-content: center;cursor: pointer;" @click="delSnLine(index)">
                <el-icon :size="22"><Remove /></el-icon>
              </div>
              </div>
            </el-row>
          </div>
          <el-form-item label="备注：" style="margin-top: 10px">
            <el-input type="textarea" rows="2" v-model="busData.remark" style="width: 100%;" :disabled="isDisable"></el-input>
          </el-form-item>
          <div style="width:100%;text-align: center;">
            <el-button style="width: 150px;margin-top: 10px" type="primary" @click="save" :disabled="isDisable">保存</el-button>
            <span v-if="isReview && !isDisable" style="margin-left: 10px;line-height: 32px;font-size: 12px">{{'(已保存)'}}</span>
          </div>
        </el-form>
      </div>

    </div>
</template>

<script>
import {CirclePlus, Remove} from "@element-plus/icons-vue";
import {nanoid} from "nanoid";


export default {
  name: "CrmWinInfo",
  components: {CirclePlus, Remove},
  inject: ['$fn'],

  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      twoDProductList:[],
      threeDProductList:[],
      snList:[],
      companyList:[],
      isDisable:false,
      is_review:false,
      isReview:false,
      busData:{
        productRemindList: [{id: nanoid(),maintenancePhase:'第1年'}],
      },
      rules: {
        is335: [{required: true, message: '请选择是否335', trigger: 'blur'}],
        contractBelongCompany: [{required: true, message: '请选择合同签署公司', trigger: 'blur'}],
        isNewCustomer: [{required: true, message: '请选择是否新客户', trigger: 'blur'}],
        isOneOrder: [{required: true, message: '请选择是否一套订单', trigger: 'blur'}],
        isBigOrder: [{required: true, message: '请选择是否大单', trigger: 'blur'}],
        isManyOrder: [{required: true, message: '请选择是否1拖N订单', trigger: 'blur'}],
        isLcOrder: [{required: true, message: '请选择是否LC订单', trigger: 'blur'}],
        lcType: [{required: true, message: '请选择LC类型', trigger: 'blur'}],
        dassaultResponsibleUser: [{required: true, message: '请选择达索负责人', trigger: 'blur'}],
        // lawyer: [{required: true, message: '请选择律师', trigger: 'blur'}],
        is2dTo2d: [{required: true, message: '请选择是否2D-2D订单', trigger: 'blur'}],
        originally2dProduct: [{required: true, message: '请选择原2D产品', trigger: 'blur'}],
        is3dTo3d: [{required: true, message: '请选择是否3D-3D订单', trigger: 'blur'}],
        originally3dProduct: [{required: true, message: '请选择原3D产品', trigger: 'blur'}],
        snInfoList: {
          maintainStartDate: [{required: true, message: '请选择维护起始日期', trigger: 'blur'}],
          maintainEndDate: [{required: true, message: '请选择维护到期日期', trigger: 'blur'}]
        }
      },
    }
  },
  computed: {
    legalTypeList() {
      return this.$store.getters['core/getDictList']('legal_type');
    },
    dsLegalList() {
      return this.$store.getters['core/getDictList']('ds_legal_list');
    },
    lawyerList() {
      return this.$store.getters['core/getDictList']('lawyer_list');
    },
    maintainRenewalTypeList(){
      return this.$store.getters['core/getDictList']('maintain_renewal_type');
    }
  },

  async created() {
    await this.initForm();
    await this.getCompanyList();
  },
  methods: {
    async initForm(){
      let params = {chance_id:this.parentData.id}
      let data = await this.$http('crmWinService.getCrmWinInfo',params);
      if(data.havaData === true){
        this.busData = data;
        this.isReview = data.isReview;
        let snList = data.snList;
        this.busData.snInfoList = [];
        if(snList.length > 0){
          for (let item of snList){
            this.busData.snInfoList.push(item)
          }
        }
        //成单审核状态  优先级最高
        if(this.parentData.win_review_status){
          this.isDisable = true;
        }else if (this.parentData.is_review) {
          //审核窗口进来的 次之
          this.isDisable = false;
          this.is_review = true;
        } else {
          this.isDisable = true;
        }

      }else {
        this.isDisable = false;
      }
      await this.getTwoDAndThreeProductList();
      await this.loadingCompanyInfo();
      await this.getSnList();
    },
    async save(){
      this.$refs.crmWin.validate( async valid => {
        if (!valid) {
          return this.$message.error("有必选或必填项为空");
        }
        if(!this.busData.maintainRenewalType){
          this.busData.maintainStartDate = null;
          this.busData.maintainEndDate = null;
          this.busData.snInfoList = null;
        }
        let params = {busData:this.busData,parentData:this.parentData};
        params.is_review = this.is_review;
        await this.$http('crmWinService.saveWinInfo',params);
        this.$message.success('保存成功');
        this.busData = {};
        await this.initForm();

        let isReview = await this.$http('crmWinService.checkIsAllReview',{chance_id:this.parentData.id});
        if(isReview === true){
          this.$fn.search();
          this.$fn.closeWindow();
        }

      });
    },
    selectAll(index){
      if(this.busData.productRemindList[index].all){
        this.busData.productRemindList[index].thirtyDays = true;
        this.busData.productRemindList[index].sixtyDays = true;
        this.busData.productRemindList[index].ninetyDays = true;
      }else {
        this.busData.productRemindList[index].thirtyDays = false;
        this.busData.productRemindList[index].sixtyDays = false;
        this.busData.productRemindList[index].ninetyDays = false;
      }
    },

    async loadingCompanyInfo(){
      let params = { company_id:this.parentData.company_id }
      let data = await this.$http('companyService.getCompanyById',params);
      this.busData.companyName = data.name
      this.busData.companyNo = data.company_no;
      this.busData.taxAddress = data.tax_address;
      this.busData.taxPhone = data.tax_phone;
      this.busData.taxBankName = data.tax_bank_name;
      this.busData.paymentDate = data.payment_date;
      this.busData.invoicinDate = data.invoicing_date;

    },
    async getCompanyList(){
      let data = await this.$http('crmTeamService.getCompanyList');
      this.companyList = data;
    },
    async getTwoDAndThreeProductList(){
      this.twoDProductList = await this.$http('crmProductService.get2dProduct');
      this.threeDProductList = await this.$http('crmProductService.get3dProduct');
    },
    async getSnList(){
      let params = {company_id:this.parentData.company_id}
      this.snList = await this.$http('crmWinService.getSnList',params);
    },
    addSnInfoListLine(){
      if(this.busData.maintainRenewalType){
        if(this.busData.snInfoList === undefined){
          this.busData.snInfoList = [];
        }
        if(this.busData.snInfoList.length > 0){
          return;
        }
        this.busData.snInfoList.push({
          id: nanoid(),
        })
      }
    },
    addLine(){
      if(this.isDisable === true){
        return;
      }
      this.busData.productRemindList.push({
        id: nanoid(),
        maintenancePhase: '第'+(this.busData.productRemindList.length+1)+'年'
      })
    },
    delLine(index){
      if(this.isDisable === true){
        return;
      }
      if(this.busData.productRemindList.length === 1){
        return;
      }
      this.busData.productRemindList.splice(index,1);
      this.busData.productRemindList.forEach((item,index)=>{
        item.maintenancePhase = '第'+(index+1)+'年'
      })
    },
    addSnLine(){
      if(this.isDisable === true){
        return;
      }
      this.busData.snInfoList.push({
        id: nanoid(),
      })
    },
    delSnLine(index){
      if(this.isDisable === true){
        return;
      }
      if(this.busData.snInfoList.length === 1){
        return;
      }
      this.busData.snInfoList.splice(index,1)
    },

  }
}
</script>

<style scoped>


</style>